export default __webpack_public_path__ + "static/media/History.a5c987fe.svg";